import { Text, ToggleGroup } from "@instructure/ui";
import { t } from "i18next";
import { Card } from "../Card";
import ArchivedOutcome from "./ArchivedOutcome";
import { isArchived, sortOutcomes } from "./utils";

const ArchiveToggle = ({ label, categories, uncategorizedLos }) => {
  const archivedUncategorizedLos = sortOutcomes(
    uncategorizedLos.filter((lo) => isArchived(lo))
  );

  const filterCategories = (categories) => {
    const archiveCategories = [];
    categories.forEach((category) => {
      const archivedLos = sortOutcomes(
        category.outcomes.filter((lo) => isArchived(lo))
      );
      if (archivedLos.length > 0) {
        archiveCategories.push({ ...category, outcomes: archivedLos });
      }
    });
    return archiveCategories;
  };
  const archivedLosInCategories = filterCategories(categories);

  return (
    (archivedUncategorizedLos.length > 0 ||
      archivedLosInCategories.length > 0) && (
      <ToggleGroup toggleLabel={label} summary={label}>
        {archivedUncategorizedLos.length > 0 && (
          <ToggleGroup
            defaultExpanded
            toggleLabel={t("categories.uncategorized")}
            summary={t("categories.uncategorized")}
            border={false}
          >
            {archivedUncategorizedLos.map((outcome, key) => (
              <Card
                key={key}
                style={{
                  color: "#0D323F",
                  backgroundColor: "#F2F8FA",
                  border: "1px solid #ccc",
                  borderRadius: 10,
                  padding: "5px 15px 15px 15px",
                  margin: 15,
                }}
              >
                <ArchivedOutcome outcome={outcome} />
              </Card>
            ))}
          </ToggleGroup>
        )}
        {archivedLosInCategories.length > 0 &&
          archivedLosInCategories.map((category, key) => (
            <ToggleGroup
              key={key}
              defaultExpanded
              toggleLabel={category.name}
              summary={
                <Text>
                  {category.name}{" "}
                  <Text fontStyle="italic">
                    {"(" + category.description + ")"}
                  </Text>
                </Text>
              }
              border={false}
            >
              {category.outcomes.map((outcome, index) => (
                <Card
                  key={index}
                  style={{
                    color: "#0D323F",
                    backgroundColor: "#F2F8FA",
                    border: "1px solid #ccc",
                    borderRadius: 10,
                    padding: "5px 15px 15px 15px",
                    margin: 15,
                  }}
                >
                  <ArchivedOutcome outcome={outcome} />
                </Card>
              ))}
            </ToggleGroup>
          ))}
      </ToggleGroup>
    )
  );
};

export default ArchiveToggle;
